/**
 * Rotating JSON backups of the rules table under app-config/backups/ (Spec §09a).
 * Uses raw IndexedDB records so restore can use importRulesJson.
 */

import { getAllRules } from './storage.js';
import { getState } from '../state.js';
import { ensureWritable } from '../folders.js';

let debounceTimer = null;

export function scheduleRulesBackup() {
  clearTimeout(debounceTimer);
  debounceTimer = setTimeout(() => {
    writeRulesBackup().catch(err => console.warn('Rules auto-backup failed:', err));
  }, 500);
}

/**
 * Immediate backup (manual trigger from settings).
 */
export async function writeRulesBackupNow() {
  await writeRulesBackup();
}

async function writeRulesBackup() {
  const state = getState();
  const h = state.appConfigHandle;
  if (!h) return;
  if (!(await ensureWritable(h))) return;

  const rules = await getAllRules();
  const json = JSON.stringify({
    marker: 'wiseentry-rules',
    version: 2,
    exportedAt: new Date().toISOString(),
    rules
  }, null, 2);

  const dir = await h.getDirectoryHandle('backups', { create: true });
  const stamp = new Date().toISOString().replace(/[:.]/g, '-');
  const name = `rules-${stamp}.json`;
  const fh = await dir.getFileHandle(name, { create: true });
  const w = await fh.createWritable();
  await w.write(json);
  await w.close();

  const maxKeep = Math.min(20, Math.max(1, state.settings.backupRuleGenerations ?? 5));
  const entries = [];
  for await (const [n, e] of dir.entries()) {
    if (e.kind === 'file' && n.startsWith('rules-') && n.endsWith('.json')) {
      entries.push(n);
    }
  }
  entries.sort();
  while (entries.length > maxKeep) {
    const oldest = entries.shift();
    try {
      await dir.removeEntry(oldest);
    } catch { /* ignore */ }
  }
}
